'use strict'
const reg = /^[0-9]*$/
// 校验规则
const complany = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请填写公司名称'))
  } else {
    callback()
  }
}
const user = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请填写您的名字'))
  } else {
    callback()
  }
}
const phone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请填写您的手机号码'))
  } else if (!reg.test(value)) {
    callback(new Error('请输入数字'))
  } else {
    callback()
  }
}
const codes = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请填写验证码'))
  } else {
    callback()
  }
}

const ruleObj = {
  complanyNmame: [{ validator: complany, trigger: 'blur' }],
  userName: [{ validator: user, trigger: 'blur' }],
  phoneMenber: [{ validator: phone, trigger: 'blur' }],
  code: [{ validator: codes, trigger: 'blur' }],
}
export { ruleObj }
